import { Injectable } from '@angular/core';
import { ViewIntegracionBlackboardCrearComponent } from './view-integracion-blackboard-crear/view-integracion-blackboard-crear.component';
import { IGetAsignaturasResponse } from 'src/app/interfaces/integracion-blackboard';
import { ViewIntegracionBlackboardInicioComponent } from './view-integracion-blackboard-inicio/view-integracion-blackboard-inicio.component';
import { IntegracionesBlackboardService } from 'src/app/services/integraciones-blackboard/integraciones-blackboard.service';


interface IParam {
  currPage: number;
  pageSize: number;
  search: string;
}
@Injectable({
  providedIn: 'root'
})
export class IntegracionSharedService {

  constructor(private readonly _integracionService: IntegracionesBlackboardService) { }

  getAsignaturas( doc: ViewIntegracionBlackboardCrearComponent | ViewIntegracionBlackboardInicioComponent, params: IParam) {
    doc.loadingSigla = true;
    this._integracionService
      .getAsignaturas(params.search, params.currPage, params.pageSize)
      .subscribe({
        next: (res: IGetAsignaturasResponse) => {
          doc.loadingSigla = false;
          doc.filtroAsignaturas = res;

          doc.siglaAsignaturaPaginacion.totalPages = res.totalPages;
          doc.siglaAsignaturaPaginacion.currPage = res.currentPage;
          doc.siglaAsignaturaPaginacion.totalItems = res.totalItems;
          if (doc.siglaAsignaturaPaginacion.currPage > 1) {
            const myDiv = document.getElementsByClassName("scroll-host")[0];
            myDiv.scrollTop = 0;
          }
        },
        error: () => {
          doc.loadingSigla = false;
          doc.filtroAsignaturas = {} as IGetAsignaturasResponse;
        },
      });
  }
  endScrollSigla( doc: ViewIntegracionBlackboardCrearComponent | ViewIntegracionBlackboardInicioComponent,term: string): void {
    let reqParams: IParam = {
      currPage: (doc.siglaAsignaturaPaginacion.currPage ?? 1) + 1,
      pageSize: doc.siglaAsignaturaPaginacion.pageSize,
      search: term,
    };
    if (
      doc.siglaAsignaturaPaginacion.currPage <
        doc.siglaAsignaturaPaginacion.totalPages &&
      term !== ""
    ) {
      this.getAsignaturas(doc,reqParams);
    }
  }
}
